import React, { useState } from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { brokerTitles } from '../../../../../common/SharedConstants';
import { TextBox, DropDownBox } from '@apply/components';
import { isMobileScreen, ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TitleSelectFieldProps {
    readOnly: boolean;
}

export const TitleSelectField: React.FC<TitleSelectFieldProps> = ({ readOnly = false }) => {
    const titleSelect = useBrokerDetailsStore((s) => s.titleSelect);
    const title = useBrokerDetailsStore((s) => s.title);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const changed = useBrokerFieldFieldChanged(FormField.Title);
    const isMobile = isMobileScreen();

    const [showCustomTitle, setShowCustomTitle] = useState(titleSelect === 'Custom');

    const handleTitleSelectChange = (value: string) => {
        setShowCustomTitle(value === 'Custom');

        if (brokerTitles.includes(value)) {
            updateFields({ title: value, titleSelect: value });
        } else if (value === 'Custom') {
            updateFields({ titleSelect: 'Custom' });
        } else {
            updateFields({ title: '', titleSelect: '' });
        }
    };

    return (
        <>
            <DropDownBox
                id='title'
                value={titleSelect}
                onChange={handleTitleSelectChange}
                label="Broker's Title at Company"
                required={true}
                dataSource={[...brokerTitles, 'Custom']}
                width={isMobile ? '100%' : showCustomTitle ? '50%' : '100%'}
                placeholder='Select'
                readOnly={readOnly}
            />
            {showCustomTitle && (
                <TextBox
                    id='customTitle'
                    value={title}
                    onChange={(v) => updateFields({ title: v })}
                    label='Custom Broker Title'
                    width={isMobile ? '100%' : '50%'}
                    required={true}
                    readOnly={readOnly}
                />
            )}
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
